// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}._19bvze3t{padding-left:var(--ds-space-0,0)}\n._bfhksm61{background-color:var(--ds-background-neutral-subtle,#00000000)}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._p12f1osq{max-width:100%}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}", ""]);
// Exports
module.exports = exports;
